import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useWorkingCapitalFiltersContext } from '../Contexts/WorkingCapitalFiltersProvider';
import MultiSelect from 'SpendController/Components/MultiSelect/MultiSelect';
import {
	ApButtonIcon,
	ApCheckbox,
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
	colors,
} from '@alixpartners/ui-components';
import { SingleFilterWrapper } from 'SpendController/Components/Components.styles';
import { useSavingCalculationContext } from '../Contexts/SavingCalculationProvider';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import AgGridTable from './AgGridTable';
import { SectionWrapper } from 'Investigate/Investigate.styles';
import {
	ContentCenterDiv,
	FiltersContainer,
	FiltersListDiv,
} from './SavingCalculation.styles';
import {
	Header,
	Title,
} from 'Investigate/RegionalSection/RegionalSection.styles';
import SavingCalculationSettings from './SavingCalculationSettings';
import { Breadcrumbs, ChartAndTableContainer } from '../WorkingCapital.styles';

function SavingCalulation({ setCurrentContent }) {
	const {
		currentBreakDownFilter,
		currentFilterOptions,
		currentFilterValuesSelected,
		setcurrentFilterValuesSelected,
		handleFilterByChange,
		breakDownFilters,
		setTableData,
		dateRangeData,
		handleDateRangeChange,
	} = useWorkingCapitalFiltersContext();

	const {
		options,
		tableData,
		data,
		isLoading,
		getSavingCalculationData,
		isWaccEnabled,
		setIsWaccEnalbled,
		setIsLoading,
	} = useSavingCalculationContext();

	const [closeSettings, setCloseSettings] = useState(false);

	const isEmpty = obj => JSON.stringify(obj) === '{}';

	useEffect(() => {
		if (
			currentFilterValuesSelected.length === 0 &&
			currentFilterOptions.length > 0 &&
			!data
		) {
			setcurrentFilterValuesSelected([currentFilterOptions[0].value]);
		} else if (currentFilterValuesSelected.length > 0) {
			getSavingCalculationData();
		}
	}, []);

	return (
		<>
			<Breadcrumbs>
				<span onClick={() => setCurrentContent(0)}>Category Widgets</span>&nbsp;/&nbsp;<span
				>
					WC Improvement
				</span>
			</Breadcrumbs>
			<FiltersContainer>
				<FiltersListDiv>
					<ApSimpleDropdown
						label={`Filter By`}
						onChange={e => handleFilterByChange(e)}
						options={breakDownFilters}
						selected={breakDownFilters.find(
							e => e.value === currentBreakDownFilter.value
						)}
					/>
					<SingleFilterWrapper>
						<MultiSelect
							name={`${currentBreakDownFilter.label}`}
							label={`${currentBreakDownFilter.label}`}
							options={currentFilterOptions}
							selected={currentFilterValuesSelected}
							onChange={v => {
								setcurrentFilterValuesSelected(v);
							}}
						/>
					</SingleFilterWrapper>
					{dateRangeData.srcRange &&
						dateRangeData.stateRange && (
							<MonthPicker
								srcRange={dateRangeData.srcRange}
								stateRange={dateRangeData.stateRange}
								onConfirm={handleDateRangeChange}
							/>
						)}

					<ApCheckbox
						id="wacc"
						name="wacc"
						checked={isWaccEnabled}
						onChange={e => {
							setIsWaccEnalbled(e.target.checked);
							setIsLoading(true);
						}}
					>
						WACC
					</ApCheckbox>
				</FiltersListDiv>
				<div style={{ marginRight: '10px' }}>
					<ApButtonIcon
						title={`Filters`}
						iconName="settings"
						iconProps={{ iconColor: colors.grey8 }}
						onClick={() => setCloseSettings(true)}
					/>
				</div>
			</FiltersContainer>

			<SavingCalculationSettings
				closeSettings={closeSettings}
				setCloseSettings={setCloseSettings}
			/>

			{!isLoading ? (
				!isEmpty(data) ? (
					data ? (
						<ChartAndTableContainer>
							<SectionWrapper>
								<Header>
									<Title>Working Capital Optimization</Title>
								</Header>

								<HighchartsReact highcharts={Highcharts} options={options} />
							</SectionWrapper>
							<AgGridTable tableData={tableData} setTableData={setTableData} />
						</ChartAndTableContainer>
					) : (
						<ContentCenterDiv>
							please select a filter to see data
						</ContentCenterDiv>
					)
				) : (
					<ContentCenterDiv>No data available</ContentCenterDiv>
				)
			) : (
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			)}
		</>
	);
}

export default SavingCalulation;
